<mat-form-field #fallbackOverlayOrigin="cdkOverlayOrigin"
                subscriptSizing="dynamic"
                (click)="toggle()"
                cdk-overlay-origin>
    <mat-label *ngIf="label">{{label}}</mat-label>
    <input [value]="displayValue"
           #trigger
           matInput
           [disabled]="disabled"
           [placeholder]="placeholder"
           [required]="required" />
    <mat-hint *ngIf="hint">
        {{hint}}
    </mat-hint>
    <ng-container *ngIf="hasSuffix"
                  matSuffix>
        <ng-content select="[suffix]"></ng-content>
    </ng-container>
    <ng-container *ngIf="hasPrefix"
                  matPrefix>
        <ng-content select="[prefix]"></ng-content>
    </ng-container>
    <ng-container *ngIf="hasError"
                  matError>
        <ng-content select="[error]"></ng-content>
    </ng-container>
</mat-form-field>

<ng-template cdk-connected-overlay
             (overlayOutsideClick)="close()"
             [cdkConnectedOverlayOpen]="panelOpen"
             [cdkConnectedOverlayOrigin]="trigger">
    <mat-tree [dataSource]="dataSource"
              [treeControl]="treeControl"
              class="st-tree-menu"
              #control>
        <mat-tree-node *matTreeNodeDef="let node"
                       class="st-tree-menu-item"
                       matTreeNodePadding
                       matTreeNodeToggle>
            <div (click)="handleSelected(node)"
                 class="st-tree-menu-item__label"
                 [class.st-tree-menu-item__label--selected]="node.selected">{{node?.value}}
                <mat-icon>done</mat-icon>
            </div>
        </mat-tree-node>
        <mat-tree-node *matTreeNodeDef="let node; when: hasChild"
                       class="st-tree-menu-item"
                       matTreeNodePadding>
            <button mat-icon-button
                    matTreeNodeToggle>
                <mat-icon class="mat-icon-rtl-mirror">
                    {{treeControl.isExpanded(node) ? 'arrow_drop_up' : 'arrow_drop_down'}}
                </mat-icon>
            </button>
            <div (click)="handleSelected(node)"
                 class="st-tree-menu-item__label"
                 [class.st-tree-menu-item__label--selected]="node.selected">{{node?.value}}
                <mat-icon>done</mat-icon>
            </div>
        </mat-tree-node>
    </mat-tree>
</ng-template>